import { buildItemQuery } from '@/graphql/index';
import { QaAnswerFrag } from '@/graphql/fragments/QaAnswerFrag';
import { QaServiceFrag } from '@/graphql/fragments/QaServiceFrag';
import { QaQuestionFrag } from '@/graphql/fragments/QaQuestionFrag';

export const getQAContainerAnswerQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'QaAnswerFrag', QaAnswerFrag);

export const getQAContainerServiceQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'QaServiceFrag', QaServiceFrag);
export const getQAContainerQuestionQuery = (id: string, lang = 'en-US') =>
  buildItemQuery(id, lang, 'QaQuestionFrag', QaQuestionFrag);
